import { CrossIcon, SmallMagnifyingGlassIcon } from '@/assets/svgIcons'
import React from 'react'

interface Props {
  id?: string
  inputValue: string
  onChange: (val: string) => void
  onClear: () => void
  inputRef: React.RefObject<HTMLInputElement>
}

const SearchInput: React.FC<Props> = ({
  id,
  inputValue,
  onChange,
  onClear,
  inputRef,
}) => (
  <div className='flex border border-border w-full p-2 rounded-radius-sm flex-row items-center'>
    <div className='mr-2'>
      <SmallMagnifyingGlassIcon />
    </div>
    <input
      id={id}
      data-testid={id}
      type='text'
      className='flex-1 bg-primary text-primary-foreground text-md outline-none'
      placeholder='Enter text'
      onChange={e => onChange(e.target.value)}
      maxLength={50}
      ref={inputRef}
      value={inputValue}
    />
    {inputValue && (
      <button
        className='ml-2 cursor-pointer hover:opacity-80 flex-shrink-0'
        onClick={onClear}
        aria-label='Clear search'
      >
        <CrossIcon />
      </button>
    )}
  </div>
)

export default SearchInput
